"use strict";

var _regeneratorRuntime = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib"); // @ts-ignore: Could not find a declaration file for module


var inspector = require("schema-inspector");

var profileTokens_1 = require("./profileTokens");

var profileProofs_1 = require("./profileProofs");

var profileZoneFiles_1 = require("./profileZoneFiles");

var schemaDefinition = {
  type: 'object',
  properties: {
    '@context': {
      type: 'string',
      optional: true
    },
    '@type': {
      type: 'string'
    }
  }
};
/**
 * Represents a user profile
 *
 */

var Profile =
/*#__PURE__*/
function () {
  function Profile() {
    var profile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Profile);

    this._profile = Object.assign({}, {
      '@context': 'http://schema.org/'
    }, profile);
  }

  _createClass(Profile, [{
    key: "toJSON",
    value: function toJSON() {
      return Object.assign({}, this._profile);
    }
  }, {
    key: "toToken",
    value: function toToken(privateKey) {
      return profileTokens_1.signProfileToken(this.toJSON(), privateKey);
    }
  }], [{
    key: "validateSchema",
    value: function validateSchema(profile) {
      var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      schemaDefinition.strict = strict;
      return inspector.validate(schemaDefinition, profile);
    }
  }, {
    key: "fromToken",
    value: function fromToken(token) {
      var publicKeyOrAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var profile = profileTokens_1.extractProfile(token, publicKeyOrAddress);
      return new Profile(profile);
    }
  }, {
    key: "makeZoneFile",
    value: function makeZoneFile(domainName, tokenFileURL) {
      return profileZoneFiles_1.makeProfileZoneFile(domainName, tokenFileURL);
    }
  }, {
    key: "validateProofs",
    value: function validateProofs(domainName, cheerio) {
      return tslib_1.__awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", profileProofs_1.validateProofs(new Profile().toJSON(), domainName, cheerio));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }]);

  return Profile;
}();

exports.Profile = Profile;